"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_COLOR_MAP = exports.Labels = exports.BACKGROUND_COLOR_MAP = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./Labels.css"));
var _uiKit = require("@cian/ui-kit");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BACKGROUND_COLOR_MAP = exports.BACKGROUND_COLOR_MAP = {
  mortgage: 'accent-main-secondary',
  installment: 'accent-main-secondary',
  newbuildingCount: 'overlay-control-dark',
  discount: 'surface-positive-default',
  bonus: 'surface-warning-default',
  sale: 'accent-main-primary',
  noOverpayments: 'accent-positive-secondary'
};
const TEXT_COLOR_MAP = exports.TEXT_COLOR_MAP = {
  mortgage: 'accent-main-primary',
  installment: 'accent-main-primary',
  newbuildingCount: 'decorative-theme-dark',
  discount: 'accent-positive-primary',
  bonus: 'decorative-theme-orange',
  sale: 'decorative-theme-white',
  noOverpayments: 'accent-positive-primary'
};
const Labels = props => {
  const {
    labels
  } = props;
  if (!labels || labels.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: style['labels']
  }, labels.map((_ref, idx) => {
    let {
      type,
      text
    } = _ref;
    return /*#__PURE__*/React.createElement(_uiKit.Label, {
      key: idx,
      color: TEXT_COLOR_MAP[type],
      background: BACKGROUND_COLOR_MAP[type]
    }, text);
  }));
};
exports.Labels = Labels;